import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ChatTag } from '../../../assets/images/ChatImages/chattag.svg';
import { ReactComponent as AddTag } from '../../../assets/images/ChatImages/label-tag.svg';
import { ReactComponent as Arrow } from '../../../assets/images/arrow.svg';
import { ReactComponent as HashTag } from '../../../assets/images/ChatImages/hashtagCircle.svg';
import { ReactComponent as Settings } from '../../../assets/images/ChatImages/settings.svg';
import { ReactComponent as BlueHash } from '../../../assets/images/ChatImages/blueHash.svg';
import { ReactComponent as BackArrow } from '../../../assets/images/ChatImages/backArrow.svg';
import rightArrow from '../../../assets/images/rightarrow.png';
import leftArrow from '../../../assets/images/leftIcon.png';
import Loader from '../../../assets/SmallLoader';
import { getTagById } from '../../../store/features/getTagById';
import { getMsgById } from '../../../store/features/getMsgById';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';


function TagMenu({setCannedResponse, onMessageSelect}) {

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  const dropdownCannedTag = useRef(null);

  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [tags, setTags] = useState([]);
  const [messages, setMessages] = useState([]);
  const [name, setName] = useState('');
  const [selectedTag, setSelectedTag] = useState(null);
  const [showManageResponses, setShowManageResponses] = useState(false);
  const [showTagsMenu, setShowTagsMenu] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isMessagesLoading, setIsMessagesLoading] = useState(true);

  useEffect(() => {
    getTagsById();
  }, []);

  const getTagsById = async () => {
    const listCoUserList = dispatch(
      getTagById({
        id: userData?.response?.user?.business_id,
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.success) {
          console.log('TAGS-----------------', data.payload.data);
          setTags(data.payload.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        setIsLoading(false);
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };


  const handleGetMsg = (id) => {
    setSelectedTag(id);
    const listCoUserList = dispatch(
      getMsgById({
        tId: id,
        bId: userData?.response?.user?.business_id,
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.success) {
          setMessages(data.payload.data);
          setName(data.payload.data[0]?.tagName)
          setIsMessagesLoading(false);
        } else {
          setIsMessagesLoading(false);
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        setIsMessagesLoading(false);
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddTag();
    }
  };

  const handleBackToTags = () => {
    setSelectedTag(null);
    setMessages([]);
  };

  const handleAddTag = () => {
    if (dropdownCannedTag.current) {
      dropdownCannedTag.current.style.display = 'none';
    }
    setCannedResponse(true);
  };

  const handleMessageClick = (msg) => {
    if (onMessageSelect) {
      onMessageSelect(msg);
    }
    if (dropdownCannedTag.current) {
      dropdownCannedTag.current.style.display = 'none';
    }
  };

  const handleHashTagClick = () => {
    setShowManageResponses(!showManageResponses);
    setShowTagsMenu(!showTagsMenu);
  };

  return (
    <div ref={dropdownCannedTag} className="dropdown-canned-tag">
      
      {isLoading ? (
        <Loader />
      ) : (selectedTag === null ? (
      <>
      {showTagsMenu && (
      <div className="tags-menu">
        <div style={{padding: '8px 10px'}}>
            General
        </div>
        <div className="dropdown-canned-tag-list">
        {tags.map((item) => (
          <ul key={item._id}>
            <li
              onClick={() => item.cannedMessageCount > 0 && handleGetMsg(item._id)}
              style={{ display: 'flex', justifyContent: 'space-between', cursor: item.cannedMessageCount > 0 ? 'pointer' : 'default' }}
              onMouseEnter={() => setHoveredItemId(item._id)}
              onMouseLeave={() => setHoveredItemId(null)}
            >
              <p
                style={{
                  color: hoveredItemId === item._id ? 'black' : 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <span style={{ marginRight: '7px', width: '14px', height: '14px'}}>
                  {hoveredItemId === item._id ? <BlueHash /> : <HashTag />}
                </span>
                {item.tag}
              </p>
              
              {item.cannedMessageCount > 0 && (
                <p style={{display: 'flex', alignItems: 'center'}}>
                  <span style={{marginRight: "10px"}} >{item.cannedMessageCount}</span>
                  <img src={rightArrow} width="10px" alt="Right Arrow" />
                </p>
              )}
            </li>
          </ul>
        ))}
        </div>
        <div className="button-container-tag">
          <button  style={{ cursor: 'default', background: 'none', border: 'none', padding: 0, display: 'flex', alignItems: 'center', color: '#148DFD', marginTop: '5px'}}>
            <span onClick={handleAddTag} style={{cursor: 'pointer', fontSize: '14px'}}>
              <AddTag style={{marginRight: '4px', paddingTop: '2px'}} />
              <span >New</span>
            </span>
            
          </button>
          <span onClick={handleHashTagClick} style={{ cursor: 'pointer' }}>
            <Settings style={{ marginTop: '8px'}} />
          </span>
        </div>
      
      </div>
      )}

      {showManageResponses && (
        <>
        <div style={{display: 'flex', marginTop: '10px', marginBottom: '5px'}}>
          <div
            onClick={handleHashTagClick}
            style={{ cursor: 'pointer' }}
          > 
            <Arrow />
            
          </div>
          <div style={{margin: '0 auto', paddingRight: '12px'}}>
            Settings
          </div>
        </div>
        <div className="manage-responses">
          <ul>
            <Link to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <li
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              Manage Responses
            </li>
            </Link>
          </ul>
        </div>
        </>
      )}
      </>
      ) : (
        <>
        {messages.length > 0 ? (
        <>
        <div style={{display: 'flex', marginTop: '10px'}}>
            <div
              onClick={handleBackToTags}
              style={{ cursor: 'pointer' }}
            > 
              <Arrow />
              
            </div>
            <div style={{margin: '0 auto', paddingRight: '10px'}}>
              {name}
            </div>
          </div>
        <div className="dropdown-canned-msg-list">
          
          {messages.map((msg) => (
            <ul key={msg._id}>
              <div style={{display: 'flex', cursor: 'pointer', background: '#F7F8F9', margin: '7px 0', padding: '5px', borderRadius: '0 16px 16px 16px'}}>
              {/* <div
                onClick={handleBackToTags}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              > 
                <img src={leftArrow} style={{ marginRight: '14px' }} width="12px" alt="Right Arrow" />
              </div> */}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleMessageClick(msg);
                }}
                style={{ display: 'flex', alignItems: 'center', flexGrow: 1, padding: '9px', fontSize: '14px',  color: '#405261'}}
              >
                <p style={{ margin: 0 }}>{msg.content}</p>
              </div>
              </div>
            </ul>
          ))}
        </div>
        </>
        ) : (
          <Loader />
        )}
        </>
      )
      )}

      
      
    </div>
  );
}
export default TagMenu;
